import { ToastrService } from 'ngx-toastr';
import { Injectable, inject } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class MsgService {

  public readonly toastr = inject(ToastrService);

  opcoes = {
    closeButton: true,
    timeOut: 5000,
    positionClass: 'toast-top-right',
    toastClass: 'ngx-toastr',
    titleClass: 'toast-title',
    messageClass: 'toast-message'
  };

  msgSucesso(msg: string) {
    this.toastr.success(msg, 'Sucesso!', this.opcoes);
  }

  msgErro(msg: string) {
    this.toastr.error(msg, 'Erro', this.opcoes);
  }

  msgAdvertencia(msg: string) {
    this.toastr.warning(msg, 'Atenção', this.opcoes);
  }

  msgInfo(msg: string) {
    this.toastr.info(msg, 'Info', this.opcoes);
  }
}
